<template>
  <div>
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Дополнительный номер телефона (родственника, знакомого)
    </div>

    <div class="wrapper">
      <div class="phone">
        <c-input
          v-model="phone"
          label="Номер телефона"
          :clearable="true"
          placeholder="+7 (___) ___ ____"
          mask="+7 (###) ### ####"
          :required="error && error.phone"
          :required-message="error && error.phone"
        />
      </div>
      <div class="name">
        <c-input
          v-model="name"
          floating-label="ФИО"
          :clearable="true"
          :max-length="255"
          :required="error && error.name"
          :required-message="error && error.name"
        />
      </div>
      <div class="status">
        <c-select
          v-model="status"
          type="select"
          floating-label="Кем приходится"
          :items="options"
          :clearable="true"
          :searchable="true"
          :custom-options="field.custom"
          :invalid="!!(error && error.status)"
          :error="error && error.status"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CInput from "@/components/controls2/Input";
import CSelect from "@/components/controls2/Select";
import { SYSTEM_TYPES, FIELD_TYPE_ADDITIONAL_PHONE } from "@/domains/profile/constants/system-types";
import { formatList } from "../utils";

const field = SYSTEM_TYPES[FIELD_TYPE_ADDITIONAL_PHONE];

export default {
  components: { CInput, CSelect },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      phone: "",
      name: "",
      status: null,
    };
  },

  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),
    dictionaryCode() {
      return field.dictionaryCode;
    },
    variants() {
      return this.dictionaries[this.dictionaryCode] || [];
    },

    options() {
      return formatList(this.variants);
    },
  },

  watch: {
    phone() {
      this.updateValue();
    },
    name() {
      this.updateValue();
    },
    status() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  async created() {
    await this.$store.dispatch("profile/getDictionary", { code: this.dictionaryCode });
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { phone, name, status } = value.value || {};

      this.phone = phone || "";
      this.name = name || "";

      if (status) {
        const { id, text, custom } = status;

        if (!this.status || this.status.value !== id) {
          this.status = {
            value: `${id}`,
            label: `${text}`,
            custom,
          };
        }
      } else {
        this.status = null;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      let statusValue = null;

      if (this.status) {
        const { value, label, custom } = this.status;
        statusValue = {
          id: value,
          text: label,
          custom,
        };
      }
      const newValue = {
        phone: this.phone,
        name: this.name,
        status: statusValue,
      };
      this.$emit("input", {
        value: newValue,
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.wrapper {
  margin-bottom: -15px;
}
.phone,
.name,
.status {
  padding-bottom: 25px;
  width: 100%;
}

.phone {
  padding-top: 6px;
}

@include bootstrapMd {
  .wrapper {
    margin-left: -15px;
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
  }
  .phone,
  .name,
  .status {
    padding-left: 15px;
    padding-right: 15px;
  }

  .phone {
    width: calc(100% / 10 * 3);
  }

  .name {
    width: calc(100% / 10 * 6);
  }

  .status {
    width: calc(100% / 10 * 3);
  }
}

@include bootstrapXl {
  .phone {
    width: calc(100% / 12 * 2);
  }

  .name {
    width: calc(100% / 12 * 6);
  }

  .status {
    width: calc(100% / 12 * 2);
  }
}
</style>
